export const environment = {
  production: false,
  baseUrl: 'https://staging.awalanagri.com/api/v1/'
};
